import { t } from "../../../i18n";
import { Modal } from "react-bootstrap";
import { Spinner } from "../../../ui/Spinner";
import { LoginStatus } from "../../../http/Types";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { UserDetailsForm } from "../../UserDetailsForm";
import { Status as JourneyStatus } from "../../../journey/UserJourneyReducer";
import { fetchJourneys } from "../../../journey/UserJourneyActions";
import { isRedirectToVerifyPrincipal } from "../../../user/ui/utils";
import { fetchAndParseContent } from "../../../contenful/ContentfulActions";
import { ContentModelName, DynamicModalContent } from "../../../contenful/types";
import Title from "../../../layout/Title";
import ModalContent from "../ui/ModalContent";
import ModalNavigation from "../ui/ModalNavigation";
import { ModalProps, PATH } from "../UserModalController";
import ModalCloseBtn from "../ui/ModalCloseBtn";
import { getContainer } from "../../../ioc/IOCSetup";
import { getDynamicContentByType, hasContent, isHomeScreen, setModalPath, useClickOutside } from "../utils";
import { handleModalPath } from "../../../user/UserActions";
import {UserJourneyAndAttributes} from "../../../http/protocol";


export function getRegistrationLoginPrincipals(journeyAndAttributes?: UserJourneyAndAttributes) {
  let principals = journeyAndAttributes?.journey?.userLoginPrincipals ?? []
  let exclude = journeyAndAttributes?.journey?.registration?.exclude ??[];
  return  principals.filter(p => !exclude.find(l => l == p));
}

const RegistrationModal = ({...rest}: Partial<ModalProps>) => {

  const {history, user, content, journey, verificationRequired, modalType } = rest;
  const homeScreen = isHomeScreen();

  const dispatch = useDispatch();
  const [dynamicContent, setDynamicContent] = useState<Partial<DynamicModalContent>>({});
  const [displayContent, setDisplayContent] = useState<boolean>(false);
  
  const ref = useRef(null);
  useClickOutside(ref, () => setModalPath({path: undefined, history})); 

  // Defualt language is set in contentful
  const [ language ] = useState(()=> {
    try {
      return getContainer().getSettingsService().getActiveLocale().code;
    } catch (_) {
      return undefined
    }
  })

  // Get journey and onboarding content 
  useEffect(()=> {
    if(content && content.onboardingpage === undefined) {
        dispatch(fetchAndParseContent(ContentModelName.ONBOARDINGPAGE, language) as any);
    }
  },[]);

  useEffect(() => {
    if(journey && journey?.status === JourneyStatus.NONE){
      dispatch(fetchJourneys() as any);
    }
  }, [journey && journey.status]);



  useLayoutEffect(()=>{
    if(content && content.onboardingpage && content.onboardingpage.dynamicContent && content.onboardingpage.dynamicContent.length !== 0){
      if(hasContent(content.onboardingpage.dynamicContent, PATH.REGISTRATION)){
        setDynamicContent(getDynamicContentByType(content.onboardingpage.dynamicContent, PATH.REGISTRATION) as Object)
        setDisplayContent(true)
      } 
    } else {
      setDisplayContent(false)
    }
  },[content])


  // Redirect to right modal based on auth proccess.
  const userStatus = user && user.status;
  const verifyEmailStatus = user && user.verifyEmailStatus; 

  useEffect(()=>{
    if(history && verificationRequired && modalType){
      if(userStatus == LoginStatus.MANUAL_APPROVAL_REQUIRED) {
        setModalPath({ path : { type : PATH.MANUAL_APPROVAL}, history});
      } else if (isRedirectToVerifyPrincipal(userStatus, verifyEmailStatus)) {
        setModalPath({path: {type: PATH.VERIFY_EMAIL, modal: PATH.NEW_USER}, history})
      }
      if(userStatus === LoginStatus.ACCEPT_TERMS_REQUIRED) {
        modalType(true)
        setModalPath({path: {type: PATH.TERMS_CONDITION, modal: PATH.NEW_USER}, history})
      }
      if(userStatus === LoginStatus.LOGGED_IN) {
        setModalPath({path: {type: PATH.REGISTER_SUCCESS, modal: PATH.MODAL_TYPE}, history})
      }
    }
    return () => {
      if (isRedirectToVerifyPrincipal(userStatus, verifyEmailStatus)) {
        dispatch(handleModalPath(true, true))
      }
    }
  },[user])


  const LoadingSpinner = <div id="sc" data-testid={PATH.REGISTRATION} ref={ref}><Spinner /></div>

  if(journey && journey?.status !== JourneyStatus.DONE){
    return LoadingSpinner
  } 

  let journeyAndAttributes = journey && journey.journey;

  return (
    <div  className={`modal-wrapper ${PATH.REGISTRATION} ${!homeScreen ? "active" : null}`} ref={!homeScreen ? ref : null}>
      {!homeScreen && <ModalCloseBtn onClick={()=>setModalPath({path: undefined, history})}/>}
      {!homeScreen && displayContent && <ModalContent 
          title={dynamicContent.title}
          text={dynamicContent.text}
          image={dynamicContent.image}
          backgroundImage={dynamicContent.backgroundImage}
          />}
        <div className="modal-container">
          <Modal.Header>
            <Title animate={true} title={t("onboardingPage.title")} />
          </Modal.Header>
          <Modal.Body>
            <UserDetailsForm 
              verification={ journeyAndAttributes?.journey?.registration?.verification }
              loginPrincipals={ getRegistrationLoginPrincipals(journeyAndAttributes) }
              userAttributes={ journeyAndAttributes?.userAttributes }
              formSteps={ journeyAndAttributes?.journey?.registration?.formSteps ?? [] }
            />
          </Modal.Body>
          <Modal.Footer>
            <ModalNavigation options={navigationOptions()} history={history} />
          </Modal.Footer>
        </div>
    </div>
  );
};


export default RegistrationModal

const navigationOptions = () => {
  return [
    {
      locales: "account.login",
      beforeAndAfterLocales: ["account.loginBefore", "account.loginAfter"],
      type: PATH.LOGIN
    }
  ];
} 
